import { render, staticRenderFns } from "./SavedArtworkBarPreview.vue?vue&type=template&id=8dcbcaaa&scoped=true"
import script from "./SavedArtworkBarPreview.vue?vue&type=script&lang=js"
export * from "./SavedArtworkBarPreview.vue?vue&type=script&lang=js"
import style0 from "./SavedArtworkBarPreview.vue?vue&type=style&index=0&id=8dcbcaaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dcbcaaa",
  null
  
)

export default component.exports